import React from 'react';
import Header from "../../components/layout/Header";
import Banner from "../../components/home/Banner";
import Footer from "../../components/layout/Footer";

const Electronics = () => {
    const banners = [
        "/laptop_hero.png",
        "https://rukminim1.flixcart.com/fk-p-flap/1600/350/image/3b12ea642f89f924.jpg?q=20",
        "https://rukminim1.flixcart.com/fk-p-flap/1600/350/image/d34fc9b3a0429712.jpg?q=20",
    ];

    return (
        <div style={{ backgroundColor: '#f1f2f4', minHeight: '100vh', paddingTop: '128px' }}>
            <Header />

            <div style={{ maxWidth: '1440px', margin: '0 auto', padding: '12px 16px' }}>

                {/* Scrolling Hero Banner */}
                <div style={{ marginBottom: '24px', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
                    <Banner images={banners} height="300px" />
                </div>

                {/* Sub-Category Navigation */}
                <div style={{ backgroundColor: 'white', padding: '24px', borderRadius: '20px', marginBottom: '32px', boxShadow: '0 1px 2px rgba(0,0,0,0.06)' }}>
                    <div style={{ display: 'flex', gap: '40px', overflowX: 'auto', paddingBottom: '8px' }} className="no-scrollbar">
                        {[
                            { name: "Laptops", img: "/laptop_cat.png" },
                            { name: "Cameras", img: "/camera_promo.png" },
                            { name: "Audio", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/489f076e03328e75.jpg?q=20" },
                            { name: "Monitors", img: "/monitor_promo.png" },
                            { name: "Storage", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/3295c5100085a363.jpg?q=20" },
                            { name: "Smart Watch", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/1d34c62dd9806e23.jpg?q=20" }
                        ].map((cat, i) => (
                            <div key={i} style={{ minWidth: '110px', cursor: 'pointer', textAlign: 'center', transition: '0.3s', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div style={{ backgroundColor: '#f8f9fa', borderRadius: '50%', padding: '16px', border: '1px solid #eee', width: '100px', height: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img src={cat.img} alt={cat.name} style={{ width: '70px', height: '70px', objectFit: 'contain' }} />
                                </div>
                                <p style={{ fontSize: '13px', fontWeight: '700', marginTop: '8px' }}>{cat.name}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Gaming Hub - Dark Theme Section */}
                <div style={{ backgroundColor: '#0f172a', padding: '48px', borderRadius: '32px', marginBottom: '48px', color: 'white' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '40px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <h2 style={{ fontSize: '28px', fontWeight: '900', letterSpacing: '-0.5px', margin: 0 }}>Gaming Hub</h2>
                            <p style={{ color: '#60a5fa', fontWeight: '700', margin: 0 }}>Power Up Your Play</p>
                        </div>
                        <span style={{ backgroundColor: '#2563eb', color: 'white', padding: '4px 16px', borderRadius: '999px', fontSize: '14px', fontWeight: '800' }}>UP TO 50% OFF</span>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '32px' }}>
                        {[
                            { title: "Graphic Cards", off: "From ₹24,999", img: "/gpu_promo.png" },
                            { title: "Gaming Laptops", off: "Min. 30% Off", img: "/gaming_laptop_promo.png" },
                            { title: "Console Acc.", off: "Flat 20% Off", img: "/promo_electronics.png" }
                        ].map((item, i) => (
                            <div key={i} style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)', padding: '24px', borderRadius: '24px', border: '1px solid rgba(255,255,255,0.1)', cursor: 'pointer', transition: '0.3s', textAlign: 'center' }}>
                                <img src={item.img} alt={item.title} style={{ height: '160px', margin: '0 auto 16px auto', objectFit: 'contain', display: 'block' }} />
                                <p style={{ fontWeight: '800', fontSize: '18px', margin: '0 0 4px 0' }}>{item.title}</p>
                                <p style={{ color: '#60a5fa', fontWeight: '700', margin: 0 }}>{item.off}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Top Picks Section */}
                <div style={{ marginBottom: '48px' }}>
                    <h2 style={{ fontSize: '22px', marginBottom: '24px', textAlign: 'start', fontWeight: '800' }}>Month's Top Picks</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '24px' }}>
                        {[1, 2, 3, 4].map(i => (
                            <div key={i} style={{ backgroundColor: 'white', padding: '24px', borderRadius: '24px', textAlign: 'start', boxShadow: '0 1px 2px rgba(0,0,0,0.06)', cursor: 'pointer', transition: '0.3s', display: 'flex', flexDirection: 'column' }}>
                                <div style={{ height: '200px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px' }}>
                                    <img src="/macbook_promo.png" alt="Product" style={{ objectFit: 'contain', height: '100%', margin: '0 auto' }} />
                                </div>
                                <p style={{ fontWeight: '700', fontSize: '15px', color: '#333', margin: '0 0 8px 0', height: '45px', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>Apple MacBook AIR Apple M2 - (8 GB/256 GB SSD/macOS Monterey)</p>
                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginTop: '4px' }}>
                                    <span style={{ fontWeight: '900', fontSize: '18px' }}>₹69,990</span>
                                    <span style={{ fontSize: '12px', color: '#718096', textDecoration: 'line-through' }}>₹99,900</span>
                                    <span style={{ fontSize: '12px', color: '#388e3c', fontWeight: '800' }}>30% off</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Electronics;

